import o from "react";
import { useTranslation as u } from "react-i18next";
import { Modal as b } from "../../../../common/components/Modal/Modal.js";
import r from "./duplicatePhoneError.module.scss.js";
function h({
  show: e,
  onClose: a,
  design: t,
  dismissOnBackdrop: c,
  dismissOnEscape: f
}) {
  const { t: l } = u(), m = {
    "--dpe-text-color": (t == null ? void 0 : t.textColor) ?? "#fff",
    "--dpe-btn-bg": (t == null ? void 0 : t.buttonBackgroundColor) ?? "#f8b233",
    "--dpe-btn-text": (t == null ? void 0 : t.buttonTextColor) ?? "#fff"
  };
  return /* @__PURE__ */ o.createElement(
    b,
    {
      show: e,
      showCloseBtn: !1,
      onClose: a,
      dismissOnBackdrop: c,
      dismissOnEscape: f,
      design: {
        backgroundColor: (t == null ? void 0 : t.backgroundColor) ?? "#302e3a",
        textColor: (t == null ? void 0 : t.textColor) ?? "#fff",
        fontFamily: t == null ? void 0 : t.fontFamily
      }
    },
    /* @__PURE__ */ o.createElement("div", { className: r.container, style: m }, /* @__PURE__ */ o.createElement("div", { className: r.title }, l("duplicatePhoneError.title")), /* @__PURE__ */ o.createElement("div", { className: r.subtitle }, l("duplicatePhoneError.subtitle")), /* @__PURE__ */ o.createElement(
      "button",
      {
        className: r.button,
        type: "button",
        onClick: a
      },
      l("duplicatePhoneError.back")
    ))
  );
}
export {
  h as DuplicatePhoneError
};
//# sourceMappingURL=DuplicatePhoneError.js.map
